import { get, patch } from 'helpers/api';
import { getCurrentFile, getImport, getPaths } from '../selectors';
import { getFileMapping } from '../selectors';

export const SET_IMPORT = 'importRequest/SET_IMPORT';
export const setImport = importer => ({
  type: SET_IMPORT,
  importer
});

export const SET_IMPORT_STATUS_TYPE = 'importRequest/SET_IMPORT_STATUS_TYPE';
export const setImportStatusType = statusType => ({
  type: SET_IMPORT_STATUS_TYPE,
  statusType
});

export const SET_IMPORT_FILES = 'importRequest/SET_IMPORT_FILES';
export const setImportFiles = files => ({
  type: SET_IMPORT_FILES,
  files
});

export const SET_MAPPING_FILE = 'importRequest/SET_MAPPING_FILE';
export const setMappingFile = currentFile => ({
  type: SET_MAPPING_FILE,
  currentFile
});

export const CLEAR_IMPORT_FILES = 'importRequest/CLEAR_IMPORT_FILES';
export const clearImportFiles = () => ({
  type: CLEAR_IMPORT_FILES
});

export const loadImportFiles = () => (
  (dispatch, getState) => {
    const state = getState();
    const paths = getPaths(state);
    const importer = getImport(state);

    return get(`${paths.import}/${importer.id}/files`)
      .then((response) => {
        dispatch(setImportFiles(response.files));
      });
  }
);

export const runImport = () => (
  (dispatch, getState) => {
    const state = getState();
    const paths = getPaths(state);
    const importer = getImport(state);
    const fileMapping = getFileMapping(state);

    return patch(`${paths.import}/${importer.id}/runs/${fileMapping.runId}`, {
      importerRun: {
        status: 'running'
      }
    });
  }
);

export const downloadImportSummary = () => (
  (dispatch, getState) => {
    const state = getState();
    const importer = getImport(state);

    window.location.assign(`${importer.runPath}/review.txt`);
  }
);

export const downloadSkippedRecords = () => (
  (dispatch, getState) => {
    const state = getState();
    const importer = getImport(state);
    const currentFile = getCurrentFile(state);

    window.location.assign(`${importer.runPath}/skipped_records.csv?file_id=${currentFile.id}`);
  }
);

export const downloadOriginalFile = () => (
  (dispatch, getState) => {
    const state = getState();
    const currentFile = getCurrentFile(state);

    window.location.assign(currentFile.downloadFilePath);
  }
);
